// AddNewSeedling.js

import { Box, Button, TextInput, Layer, Text,  Spinner, RadioButton} from "grommet";
import { useState, useEffect, useContext } from "react";
import { Search } from "grommet-icons";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import { getDBURL, generateSyncId, correctTimeZone, isValidYearString, usePopupFocus } from "../Utils/Utils";
import ParentsListWindow from "../Base components/ParentsListWindow";
import WarningPopupWindow from "../Base components/WarningPopupWindow";
import { UserContext } from "../../App";
import CultivarDetails from '../Cultivars/CultivarDetails';

const AddNewSeedling = (props) => {
    const {parentsList, onClose, newSeedlingLocations, setNewSeedlingLocations} = props;
    console.log(' 🖖 In AddNewSeedling props >> ', props);
    // console.log('newSeedlingLocations  >>  ', newSeedlingLocations);
    const currentUser = useContext(UserContext);
    // console.log("user:  ", currentUser);
    // console.log('In AddNewSeedling parentsList >> ', parentsList);

    const { loading, post } = useFetch(getDBURL());

    const [prevCode, setPrevCode] = useState('');
    // ObjectType = 1 - cultivar
    // ObjectType = 2 - station 
    const [mother, setMother] = useState({ mId: '00000000-0000-0000-0000-000000000000', mName: '', mObjectType: 0});   // mother for input field
    const [father, setFather] = useState({ fId: '00000000-0000-0000-0000-000000000000', fName: '', fObjectType: 0});   // father for input field
    const [plantingYear, setPlantingYear] = useState(new Date().getFullYear()); 

    const [openParentsListWindow, setOpenParentsListWindow] = useState(false);
    const [selectedParent, setSelectedParent] = useState({ type: '', Id: '00000000-0000-0000-0000-000000000000', Name: '', ObjectType: 0});  // on button click set parent: mother or father 

    const [newCultivar, setNewCultivar] = useState(null); // State to store new cultivar
    const [showCultivarDetails, setShowCultivarDetails]  = useState(false); // show popup with CultivarDetails 

    const [yearOfCrossing, setYearOfCrossing]= useState('');
    const [numberInCrossing, setNumberInCrossing]= useState('');

    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');  

    const [isButtonClicked, setIsButtonClicked] = useState(false);

    // Manage focus when opening modal windows
    usePopupFocus(openParentsListWindow, "parents-lst");
    usePopupFocus(showWarning, "warning-msg");
    usePopupFocus(showCultivarDetails, "cult-det");

    const closeWarning = () => {
        setShowWarning(false);
        setWarningMessage('');
    }

    const onOpenParentsListWindow = () => {
        setOpenParentsListWindow(true);
    }

    const onCloseParentsListWindow = () => {
        setOpenParentsListWindow(false);
    };

    const changeParent = (newParent) =>
    {
        // console.log('newParent >> ', newParent);
        // console.log('selectedParent >> ', selectedParent);
        if (selectedParent.type === 'mother') {           
            // newParent.cObjectType === 1 from cultivar
            // newParent.cObjectType === 2 from station
            if (newParent.cObjectType !== mother.mObjectType || newParent.cId !== mother.mId) {
                setMother({mId: newParent.cId, mName: newParent.cName, mObjectType: newParent.cObjectType});
            }                                 
        }
        else if (selectedParent.type === 'father'){
            // newParent.cObjectType === 1 from cultivar
            // newParent.cObjectType === 2 from station
            if (newParent.cObjectType !== father.fObjectType || newParent.cId !== father.fId)
                setFather({fId: newParent.cId, fName: newParent.cName,  fObjectType: newParent.cObjectType});
        }

        setSelectedParent({ type: ''});
    }


    // Function to create a new cultivar
    const createNewCultivar = () => {
        const cultivar = {
            // Id: generateSyncId(),
            CultivarID: null,
            CultivarName: '',
            Brand: '',
            Mother: '',
            Father: '',
            RootstockId: null,
            Type: null,
            Harvest: null,
            BudBreak: null,
            RainResistance: null,
            Chilling: null,
            CreateDate: null,
            CreatedBy: null,
            IsCommercial: 1,
            CommercialFromDate: null,
            SetAsCommercialBy: null,
            AddDate: null,
            AddedBy: '',
            Country: '',
            Company:'',
            Notes: '',
            LastSyncDate: null
        };
            
        // Set the selected cultivar in state
        setNewCultivar(cultivar);
    
        // Show the cultivar details
        setShowCultivarDetails(true);
    };

    const validateInput = () =>
    {
        // console.log('In validateInput !! ');
        const errors = [];

        // let found = prevCode === '';
        // // console.log('found >> ', found);
        // if (found)
        // {
        //     // console.log('found >> ', found);
        //     if(errors.length > 0)
        //         errors.push("\n\n");
        //     errors.push("Prev code can't be empty!");
        // }

        // found = (numberInCrossing === "" || numberInCrossing === "0");
        // if (found)
        // {
        //     if(errors.length > 0)
        //         errors.push("\n\n");
        //     errors.push("Number in interbreeding is not valid");
        // } 

        // const yearOfCrossingIsValid = isValidYearString(yearOfCrossing, true, 'Interbreeding Year');
        // if (!yearOfCrossingIsValid.res) {
        //     if(errors.length > 0)
        //         errors.push("\n\n");
        //     errors.push(yearOfCrossingIsValid.msg);
        // }
        
        // Helper function to check if an ID is considered empty
        const isEmptyId = (id) => id === '00000000-0000-0000-0000-000000000000' || id === undefined || id === null || id === '';

        // Check father IDs
        if (isEmptyId(father.fId)) {
            if (errors.length > 0) errors.push("\n\n");
            errors.push("Father can't be empty!");
        }

        // Check mother ID
        if (isEmptyId(mother.mId)) {
            if (errors.length > 0) errors.push("\n\n");
            errors.push("Mother can't be empty!");
        }

        const plantingYearIsValid = isValidYearString(plantingYear, true, 'Planting Year');
        if (!plantingYearIsValid.res) {
            if(errors.length > 0) errors.push("\n\n");
            errors.push(plantingYearIsValid.msg);
        }
        
        return errors;
    }

    const submitHandler = async(event) => { 
        event.preventDefault();
        const inputErr = validateInput();

        if (inputErr.length > 0) 
        {
            setWarningMessage(inputErr);
            setShowWarning(true);
            return;
        } 
        
        await insertSeedlings();
        setIsButtonClicked(true); // Set the button clicked state to true
        setNewSeedlingLocations([]);
        props.onClose();
    };
    
 
    async function insertSeedlings() {
        try {
            const seedlingPromises = newSeedlingLocations.map(async (location) => {
                const newSeedling = {
                    Id: generateSyncId(),
                    PrevCode: prevCode,
                    MotherId: mother.mObjectType === 1 || mother.mId === '00000000-0000-0000-0000-000000000000' ? null : mother.mId,
                    ExternalMother: mother.mObjectType === 2 || mother.mId === '00000000-0000-0000-0000-000000000000' ? null : mother.mId,                    
                    FatherId: father.fObjectType === 1 || father.fId === '00000000-0000-0000-0000-000000000000' ? null : father.fId,
                    ExternalFather: father.fObjectType === 2 || father.fId === '00000000-0000-0000-0000-000000000000' ? null : father.fId,
                    YearOfCrossing: yearOfCrossing,
                    NumberInCrossing: numberInCrossing,
                    PlantingYear: plantingYear,
                    Row: location.Row,
                    Column: location.Col,
                    CreateDate: correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,
                    StatusId: null,
                    LastSyncDate: correctTimeZone(new Date()),
                };
    
                try {
                    const response = await post('/insertSeedling', newSeedling);
                    // console.log('response:', response);

                    // Check if the response is successful
                    if (!response.success) {
                        throw new Error(`HTTP error! ${response.message}`);
                    }
    
                    return response.result;
                } catch (error) {
                    console.error(`🔴 Error inserting seedling at Row: ${location.Row}, Column: ${location.Col} >> `, error.message);
                    return null; // Return null or any placeholder to indicate failure
                }
            });
    
            // Wait for all insertions to complete
            const newSeedlingIds = await Promise.all(seedlingPromises);
            
            // Filter out any null values (failed insertions)
            const successfulInsertions = newSeedlingIds.filter(id => id !== null);
            // console.log('New seedling IDs:', successfulInsertions);
    
            // Trigger re-render after all seedlings are inserted
            if (successfulInsertions.length > 0) {
                props.reRender();
            } else {
                console.warn('No successful insertions to trigger re-render.');
            }
    
        } catch (error) {
            console.error('🔴 Error in insertSeedlings >> ', error.message);
        }
    };
    

    return (  
        <>
        <Layer
            id="add-seed"
            position="center"
            onEsc={() => onClose()}
            onClickOutside={() => onClose()}            
         >
            {loading && (
            <Box align="center" direction="row" gap="small" pad="small">
                <Spinner /> <Text>Loading...</Text>
            </Box>
            )}

            {showWarning && (
                <WarningPopupWindow msg={warningMessage} close={closeWarning}/>
            )}            

            <Box  align="center" justify="between" margin="small"  border>
                <Box  align="center" justify="between" margin="small"
                    background={{ size: "contain", repeat: "no-repeat", opacity: "20%", image: "url('Grape.png')" }}
                    >

                <Text weight="bold">Add new seedling:</Text>
                    <Box  justify="between" >

                        <Box align="center" direction="row" gap="small"  justify="between">
                            <Box width="120px"  margin="small">
                                <Text weight="bold">Prev code:</Text>
                                <TextInput                      
                                    value={prevCode}
                                    style={{ padding: "3px 0 3px 10px"}} 
                                    onChange={(event) => {
                                        setPrevCode(event.target.value);
                                    }}
                                />
                            </Box>
                            <Box width="120px"  margin="small">
                                <Button label="Add Cultivar" 
                                onClick={createNewCultivar}
                                style={{width: "120px"}} />    
                            </Box>
                        </Box>

                        <Box align="center" direction="row" gap="small"  justify="between">
                            <Box width="120px"  margin="small">
                                <Text weight="bold">Year Of Crossing:</Text>
                                <TextInput 
                                    type="number"                     
                                    value={yearOfCrossing}
                                    style={{ padding: "3px 0 3px 10px"}} 
                                    onChange={(event) => {
                                        setYearOfCrossing(event.target.value);
                                    }}
                                />
                            </Box> 
                            <Box width="120px"  margin="small">
                                <Text weight="bold">Number In Crossing:</Text>
                                <TextInput 
                                    type="number"                     
                                    value={numberInCrossing}
                                    style={{ padding: "3px 0 3px 10px"}} 
                                    onChange={(event) => {
                                        setNumberInCrossing(event.target.value);
                                    }}
                                />
                            </Box> 
                        </Box>

                        <Box   width="300px"  margin="small">
                            <Text weight="bold" > Mother: </Text>
                            <Box  direction="row"  border
                                onClick={()=> { 
                                    setSelectedParent({ type: 'mother'});
                                    onOpenParentsListWindow();}} 
                                    >
                                <TextInput
                                    hoverIndicator
                                    focusIndicator={false}
                                    placeholder="Select Mother..."
                                    name="motherName"
                                    size="medium"   
                                    style={{ padding: "3px 0 3px 10px"}}            
                                    // value={mother.mId !== '00000000-0000-0000-0000-000000000000' ? mother.mName : externalMother.mName}                                    
                                    value={mother.mName}
                                    plain
                                />
                                <Search style={{ margin:"5px"}}  color="brand" 
                                    // hoverIndicator 
                                />                                
                            </Box>
                        </Box>  

                        <Box  width="300px"  margin="small">
                            <Text weight="bold" > Father: </Text>
                            <Box  direction="row"  border
                                onClick={()=> {
                                    setSelectedParent({ type: 'father'});
                                    onOpenParentsListWindow();}} >
                                
                                <TextInput  
                                    hoverIndicator                                      
                                    focusIndicator={false}
                                    placeholder="Select Father..."
                                    name="fatherName"
                                    size="medium"   
                                    style={{ padding: "3px 0 3px 10px"}}            
                                    // value={father.fId !== '00000000-0000-0000-0000-000000000000' ? father.fName : externalFather.fName}
                                    value={father.fName}
                                    plain
                                />
                                <Search style={{ margin:"5px"}}  color="brand" /> 

                            </Box>                          
                        </Box>                         

                        <Box width="120px"  margin="small">
                            <Text weight="bold">Planting Year:</Text>
                            <TextInput
                                type="number"                        
                                value={plantingYear}
                                style={{ padding: "5px 0 5px 10px"}} 
                                onChange={(event) => {
                                    setPlantingYear(event.target.value);
                                }}
                            />
                        </Box>                             
                    </Box> 
                </Box>

                {openParentsListWindow &&
                <ParentsListWindow
                    parentsList={parentsList} 
                    searchValue={''}
                    onClose={onCloseParentsListWindow}
                    changeParent={changeParent}
                    prevParent={
                        selectedParent.type === 'mother' 
                            ? { Id: mother.mId, Name: mother.mName, ObjectType: mother.mObjectType } 
                            : selectedParent.type === 'father' 
                                ? { Id: father.fId, Name: father.fName, ObjectType: father.fObjectType } 
                                : {Id: '00000000-0000-0000-0000-000000000000', Name: '', ObjectType: 0 } 
                    }                    
                    >
                </ParentsListWindow>}


                <Box align="center">
                    <Box align="center" direction="row" gap="small" pad="small" justify="around">
                        <Button primary label="Add seedlings >>>" onClick={submitHandler} style={{paddingTop: '2px', paddingBottom: '2px', fontSize: '16px', color: 'white'}} disabled={isButtonClicked} />
                        <Button secondary label="Cancel" onClick={onClose} style={{ paddingTop: '2px', paddingBottom: '2px', fontSize: '16px'}} />
                    </Box>
                </Box>
            </Box>
        </Layer>

        {/* Show CultivarDetails Modal */}
        {showCultivarDetails && 
        <Layer
            id="alertmsg"
            position="center"
            modal
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
            }}
            onEsc={() => setShowCultivarDetails(false)}
            onClickOutside={() => {}}
        >
            <Box 
                overflow='auto'
                pad="small" 
                gap="small" 
                width="large"  
                background="light-3"  
                border={{ color: "brand"}}
                style={{
                    position: 'relative',
                    margin: 'auto', // Center horizontally and vertically
                }}>            
                <CultivarDetails
                    cultivar={newCultivar} // Pass the cultivar to CultivarDetails 
                    onClosePopup={() => setShowCultivarDetails(false)} 
                    createFromStation={false}
                    loadCultivarsList={props.loadParents}
                />
            </Box>   
        </Layer>                        
        } 
        </>
    );
  };
  
  export default AddNewSeedling;
  